import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { AgitationSection } from './components/AgitationSection';
import { RevelationSection } from './components/RevelationSection';
import { OfferSection } from './components/OfferSection';
import { PricingCTA } from './components/PricingCTA';
import { FAQSection } from './components/FAQSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#0a0e1a] text-slate-300 font-sans selection:bg-cyan-500/30 selection:text-cyan-100" data-id="element-0">
      <UrgencyBar data-id="element-1" />

      <main className="pt-10" data-id="element-2">
        <HeroSection data-id="element-3" />
        <PainSection data-id="element-4" />
        <AgitationSection data-id="element-5" />
        <RevelationSection data-id="element-6" />
        <OfferSection data-id="element-7" />
        <PricingCTA data-id="element-8" />
        <GuaranteeSection data-id="element-9" />
        <FAQSection data-id="element-10" />
      </main>

      <Footer data-id="element-11" />
    </div>;
}